export default "__VITE_ASSET__BnkMQuG6__"